import React from "react";

import BaseSvg from "../../../BaseSvg";
import { InjectedSvgProps } from "../../../hocs";

export default class SenseRowBoxSvg extends React.PureComponent<InjectedSvgProps> {
  render() {
    const { fillColor, className } = this.props;

    let classNames: Array<string> = ["ddbc-sense-row-box-svg"];

    if (className) {
      classNames.push(className);
    }

    return (
      <BaseSvg className={classNames.join(" ")} viewBox="0 0 43 33">
        <g clip-path="url(#clip0_10400_116)">
          <path
            d="M33.3884 32.8019C36.1648 30.7836 38.2245 28.8596 40.0014 26.3792C40.2336 26.002 40.4557 25.6247 40.6678 25.238C40.6678 25.238 40.6678 25.2192 40.6779 25.2192C40.8091 24.9834 40.9202 24.7476 41.0312 24.5118C42.2125 22.0125 42.9798 19.0983 42.9798 15.8917C42.9798 15.3541 42.9495 14.8353 42.9091 14.3261C42.9091 14.2978 42.9091 14.2695 42.9091 14.2506C42.8788 13.9394 42.8284 13.6376 42.7779 13.3358C42.5053 11.723 42.0308 10.1669 41.3543 8.67673C39.4562 5.1966 36.811 2.48982 33.3783 0.207456L33.0653 0.00939941H9.87415L9.56117 0.103712C3.57408 3.80077 0 9.82735 0 16.4481C0 23.0688 3.57408 29.1049 9.55107 32.8019L9.86405 33H33.0653L33.3783 32.8019H33.3884ZM32.3383 2.33892C33.4893 3.12172 34.5393 3.98939 35.4884 4.8665C32.9643 4.37608 30.1374 3.60271 26.7753 2.33892H32.3383ZM10.6011 30.5667C5.66401 27.3506 2.62503 22.0974 2.62503 16.4481C2.62503 10.7988 5.6741 5.54555 10.6011 2.33892H21.4142C26.3513 4.38551 33.0653 5.45124 36.4273 6.03598C38.8403 8.95967 40.3144 12.6567 40.3144 16.4481C40.3144 20.2395 38.9514 23.946 36.4273 26.8602C33.1763 27.445 26.4522 28.5107 21.4142 30.5573H10.6011V30.5667ZM26.7753 30.5667C30.1374 29.3029 33.0754 28.5201 35.4884 28.0391C34.5393 28.9162 33.4893 29.7933 32.3383 30.5667H26.7753Z"
            fill={fillColor}
          />
        </g>
        <defs>
          <clipPath id="clip0_10400_116">
            <rect width="43" height="33" fill={fillColor} />
          </clipPath>
        </defs>
      </BaseSvg>
    );
  }
}
